<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">International online payment</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <section class="existing_account_sec">
        <div class="row">
        <div class="col-sm-6" *ngFor="let item of parentdata?.bankAccounts">
            <mat-card (click)="selectAccount(item)">
                <div class="check_card_icon" [ngClass]="{'greend': item.isSelected == 1}">
                    <mat-icon>check</mat-icon>
                </div>
            <div class="existing_card_new">
                    <div class="bank_img_sc">
                       <img src="assets/images/PayPal_Logo.svg" alt=""/>
                    </div>
                    <div class="bake_name_list">
                        <h3>{{item.paypal_merchant_id}}</h3>
                        <p>Email: {{item.email}}</p>
                        <p *ngIf="item.creation_time">Added on: {{item.creation_time | date}}</p>
                    </div>
            </div>
        </mat-card>
        </div>
        </div>
    </section>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
    (click)="onPost()"
      mat-flat-button
      color="accent">
      Confirm 
    </button>
  </mat-dialog-actions>